import { WriterTypes } from '../../enums/file-writer/writer-types';
import { FileWriterConfigTypes } from '../../types/file-writer-config-types';

export class FileWriterTemplatePayload {
	stageFileID: string;
	writerType: WriterTypes;
	fileWriterConfig: FileWriterConfigTypes;

	constructor(
		stageFileID: string,
		writerType: WriterTypes,
		fileWriterConfig: FileWriterConfigTypes
	) {
		this.stageFileID = stageFileID;
		this.writerType = writerType;
		this.fileWriterConfig = fileWriterConfig;
	}
}
